import React, {useEffect, useRef, useState} from 'react';
import {createPortal} from 'react-dom';
import './PremiumGiftPopup.css';

export default function PremiumGiftPopup({eligible, userId, onVisibilityChange}) {
  const storageKey=`connext-premium-gift-2027:${userId}`;
  const [dismissed,setDismissed]=useState(()=>{
    try { return sessionStorage.getItem(storageKey)==='dismissed'; } catch { return false; }
  });
  const dialog=useRef(null);
  const open=eligible&&!dismissed;
  useEffect(()=>{
    onVisibilityChange(open);
    if(open) dialog.current?.showModal();
    else if(dialog.current?.open) dialog.current.close();
    return ()=>onVisibilityChange(false);
  },[open,onVisibilityChange]);
  const dismiss=()=>{
    try { sessionStorage.setItem(storageKey,'dismissed'); } catch {}
    setDismissed(true);
  };
  return createPortal(<dialog ref={dialog} className="premium-gift-popup" dir="rtl" aria-labelledby="premium-gift-title"
    onCancel={event=>{event.preventDefault();dismiss();}}>
    <button autoFocus type="button" className="premium-gift-close" aria-label="סגירת מתנת ההשקה" onClick={dismiss}>×</button>
    <img className="premium-gift-masks" src={`${process.env.PUBLIC_URL}/premium-theatre-masks.png`} width="120" height="120" alt="" aria-hidden="true" />
    <h2 id="premium-gift-title">מתנת ההשקה של Connext</h2>
    <p className="premium-gift-headline">Premium בחינם לכולם!</p>
    <p>פילטרים, רקעים וכלי יצירה של Premium פתוחים עד <b dir="ltr">1/1/2027</b></p>
    <p className="premium-gift-note">בחירה בין 3 אנשים זמינה למנויים בתשלום ולמקבלי מנוי אישי במתנה.</p>
    <p className="premium-gift-note">ללא תשלום וללא חידוש אוטומטי.</p>
    <button type="button" className="premium-gift-dismiss" onClick={dismiss}>מעולה, מתחילים להכיר</button>
  </dialog>,document.body);
}
